var compProva = Vue.component('prova', {
    props: {
        id                  : Number,
        codigo              : String,
        nome                : String,
        logo                : String,
        arquivo             : String,
        gabarito            : String,
        grupo               : String,
        ano                 : Number,
        numquestoes         : Number,
        qextraidas          : Number,
        aplicacao           : String,
        orgao               : Object,
        banca               : Object,
        edital              : Object,
        nivel               : String,
        areasformacao       : Array,
        areaconhecimento    : Object,
        cargos              : Array
    },
    data: function() {
        return {
            pai : vmProvas
        }
    },
    template: '#prova-template',
    methods: {
        logado: function () {

            if( ! this.pai.logado  ){
                nav.open('register');
                return false;
            }

            return true;
        },
        adicionarNaColecao: function ( prova_id ){

            if( !this.logado() ) return;

            fechaTooltips();
            vmColecoes.abrirModal( prova_id );
        },
        resolverProva: function(){

            if( !this.logado() ) return;

            this.pai.resolverProva(this.grupo, this.id);
        },
        solicitarProva: function () {

            if( !this.logado() ) return;

            ajaxPOST('/provas/solicitar', {id: this.id});
        }
    }
});

